export default __webpack_public_path__ + "images/b9aac43dd27f2633988e19bb97328d52.jpg";